import { createContext } from 'react'
import { InteractionName, InteractionType } from '@context/interaction-context/types'

type InteractionContextType = {
  name: InteractionName
  type: InteractionType
}

export const InteractionContext = createContext<InteractionContextType>({
  name: 'insurance-panel',
  type: 'check-eligibility',
})
